import { enCriticality } from './document';
import { statuses } from './file';
import { IVenture } from './venture';

export enum statusesDashboard {
  'APPROV' = 'APPROV',
  'APPROV_NOTICE' = 'APPROV_NOTICE',
  'DISAPPROV' = 'DISAPPROV',
  'PENDING' = 'PENDING',
  'EXPIRED' = 'EXPIRED',
  'ACTIVE_DOCUMENTS' = 'ACTIVE_DOCUMENTS',
  'NOT_UPLOADED' = 'NOT_UPLOADED',
  'NEAR_EXPIRATION' = 'NEAR_EXPIRATION',
  'MONTHLY_EXPIRATION' = 'MONTHLY_EXPIRATION'
}

export const allowedGraphStatuses = [
  statusesDashboard.APPROV,
  statusesDashboard.DISAPPROV,
  statusesDashboard.PENDING,
  statusesDashboard.EXPIRED,
  statusesDashboard.NOT_UPLOADED,
];

export enum statusesColors {
  'APPROV' = '#8DC640',
  'APPROV_NOTICE' = '#5058FF',
  'DISAPPROV' = '#E24C4B',
  'PENDING' = '#AEC5DE',
  'EXPIRED' = '#7B061B',
  'ACTIVE_DOCUMENTS' = '#30009C',
  'NOT_UPLOADED' = '#FF9D00',
  'NEAR_EXPIRATION' = '#69D5F0',
  'MONTHLY_EXPIRATION' = '#EACF14'
}

export const getStatusLabel = (status: string, multiples: boolean = false) => {
  switch (status) {
  case statusesDashboard.APPROV:
    return 'Aprovados';
  case statusesDashboard.APPROV_NOTICE:
    return 'Aprovados com ressalva';
  case statusesDashboard.DISAPPROV:
    return 'Reprovados';
  case statusesDashboard.EXPIRED:
    return 'Vencidos';
  case statusesDashboard.ACTIVE_DOCUMENTS:
    return 'Documentos Aplicáveis';
  case statusesDashboard.NEAR_EXPIRATION:
    return 'Á vencer';
  case statusesDashboard.MONTHLY_EXPIRATION:
    return 'Vencimento no mês';
  case statusesDashboard.NOT_UPLOADED:
    return 'Não inseridos';
  case 'NO_DOCUMENTS':
    return 'Sem documentos';
  case statusesDashboard.PENDING:
  default:
    return 'Pendentes';
  }
};

export interface IStatusMetrics {
  status: statusesDashboard;
  value: number;
}

interface IEntityMetrics {
  entityId: number;
  entityName: string;
  data: IStatusMetrics[];
}

export interface IVentureStatusMetrics {
  ventureId: number;
  ventureName: string;
  statusByVenture?: IStatusMetrics[];
  statusByEntity?: IEntityMetrics[];
}

export interface ICriticalityMetrics {
  criticality: enCriticality;
  value: number;
}

export interface IScoreMetrics {
  score: number;
  max: number;
}

export interface IHistory {
  month: string;
  [statusesDashboard.APPROV]: number;
  [statusesDashboard.APPROV_NOTICE]: number;
  [statusesDashboard.DISAPPROV]: number;
  [statusesDashboard.EXPIRED]: number;
  [statusesDashboard.PENDING]: number;
}

export interface IHistoryMetrics {
  ventureId: number;
  ventureName: string;
  entityId?: number;
  entityName?: string;
  statusByMonth: IHistory[];
}

export interface IVentureHistoryMetrics {
  ventures: IVenture[];
  status: {
    data: { month: string;[key: number]: number }[];
    status: statuses;
  }[]
}
